module.exports = __webpack_public_path__ + "static/media/gr.41733700.svg";